import { Component, Input, OnInit } from '@angular/core';
import type { Bank } from '@modules/process/models/bank';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-connecting-accounts-loader',
  templateUrl: './connecting-accounts-loader.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class ConnectingAccountsLoaderComponent implements OnInit {
  @Input() currentBank!: Bank;
  @Input() isTestBankConnector!: boolean;
  @Input() count!: number;

  constructor(private tracker: TrackerService) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'ACCOUNT_LOADER', taggingPayload: this.count });
  }
}
